import { render } from "./TablaSolicitados.vue?vue&type=template&id=d8c3af56&ts=true"
import script from "./TablaSolicitados.vue?vue&type=script&lang=ts"
export * from "./TablaSolicitados.vue?vue&type=script&lang=ts"

import "./TablaSolicitados.vue?vue&type=style&index=0&id=d8c3af56&lang=scss"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__